import i18n from "../../../../../../../constants/i18n";
import Et3Image from "../../../../../../../core/et3-Image";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const IsSeenTick = withLiteObserverAndTheme<{
  isSeenMessage: boolean;
  isKhattabaMessage: boolean;
}>((props) => {
  const { isSeenMessage, isKhattabaMessage } = props;
  const shouldShowTick = isKhattabaMessage && isSeenMessage;

  return (
    <ET3Div
      width={30}
      height={40}
      alignItems={"center"}
      fDirection={"row"}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
      style={{}}
    >
      {shouldShowTick ? (
        <Et3Image
          type="LOCAL"
          alt={i18n.get("USER")}
          imageName={"khattaba-seen-tick"}
          size={18}
          onClick={() => {}}
          style={{}}
        />
      ) : null}
    </ET3Div>
  );
});

export default IsSeenTick;
